import type { SVGProps } from "react";
const SvgIconCross = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="m547.36 512 190.92-190.92c9.76-9.76 9.76-25.59 0-35.36-9.76-9.76-25.59-9.76-35.36 0L512 476.64 321.08 285.72c-9.76-9.76-25.59-9.76-35.36 0-9.76 9.76-9.76 25.59 0 35.36L476.64 512 285.72 702.92c-9.76 9.76-9.76 25.59 0 35.36 4.88 4.88 11.28 7.32 17.68 7.32s12.8-2.44 17.68-7.32L512 547.36l190.92 190.92c4.88 4.88 11.28 7.32 17.68 7.32s12.8-2.44 17.68-7.32c9.76-9.76 9.76-25.59 0-35.36z" />
  </svg>
);
export default SvgIconCross;
